import { createReducer, on } from '@ngrx/store';
import * as ReportActions from './final-report.actions';
import { FinalReport } from './final-report.model';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface FinalReportState {
    Report: FinalReport | null;
    isLoading: boolean;
    isAvailable: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialFinalReportState: FinalReportState = {
    Report: null,
    isLoading: false,
    isAvailable: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// Report
export const finalReportReducer = createReducer(
    initialFinalReportState,

    // On generate report
    on(ReportActions.generateFinalReport, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(ReportActions.generateFinalReportSuccess, (state, { report }) => ({
        ...state,
        isLoading: false,
        isAvailable: true,
        Report: report,
    })),
    on(ReportActions.generateFinalReportFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        isAvailable: false,
        error: error,
    })),

    // Clear
    on(ReportActions.clearPreviousFinalReport, (state) => ({
        ...state,
        isLoading: false,
        isAvailable: false,
        Report: null,
    }))
);
